import styled, { css } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export const StyledImage = styled(LazyLoadImage)`
  /* width: 100%;
  height: 100%;
  background-size: 100%; */
  ${({ width: contentWidth }) =>
    contentWidth &&
    css`
      height: auto;
      width: ${contentWidth};
    `}

  ${({ height: contentHeight }) =>
    contentHeight &&
    css`
      width: auto;
      height: ${contentHeight};
    `}
`;
